import { useOutletContext } from 'react-router-dom';
import { DashboardHeader } from '../components/dna/DashboardHeader';

const Community = () => {
  const { toggleMobileMenu } = useOutletContext();

  return (
    <>
      <DashboardHeader
        title="Communauté"
        subtitle={`Interagissez avec vos fans · ${new Date().getFullYear()}`}
        onMenu={toggleMobileMenu}
      />
      <div className="dashboard-content">
      <div className="community-placeholder">
        <div className="placeholder-icon"><i className="fa-solid fa-comments" style={{ fontSize: 32 }} /></div>
        <span className="content-kicker">Bientôt disponible</span>
        <h2>La communauté arrive bientôt.</h2>
        <p>Nous préparons un espace pour interagir avec vos fans, partager vos actualités et mieux comprendre votre audience.</p>
      </div>
      </div>
    </>
  );
};

export default Community;
